<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>导出SN号</span>
                </div>
            </div>
            <el-form :inline="true" ref="exportSN" :model="snData" class="demo-form-inline" :rules="formRule" label-width="80px" label-position="right">
                <el-form-item label="生产厂家" prop="manufacturer">
                    <el-input v-model="snData.manufacturer" placeholder="生产厂家"></el-input>
                </el-form-item>
                <el-form-item label="机型代码" prop="model_code">
                    <el-input v-model="snData.model_code" placeholder="机型代码"></el-input>
                </el-form-item>
                <el-form-item label="国家代码" prop="country">
                    <el-input v-model="snData.country" placeholder="国家代码"></el-input>
                </el-form-item>
                <el-form-item label="年份" prop="year">
                    <el-input v-model="snData.year" placeholder="年份"></el-input>
                </el-form-item>
                <el-form-item label="月份" prop="month">
                    <el-input v-model="snData.month" placeholder="月份"></el-input>
                </el-form-item>
                <el-form-item label="批次号" prop="batch_code">
                    <el-input v-model="snData.batch_code" placeholder="批次号"></el-input>
                </el-form-item>
                <el-form-item label="数量" prop="number">
                    <el-input v-model="snData.number" placeholder="数量" maxlength="4"></el-input>
                </el-form-item>
            </el-form>
            <div class="sn">{{ 'SN号：' + sn}}</div>
            <div class="button" @click="onSubmit" v-if="roleCheck('106-103-101-102')">
                <span>提交</span>
            </div>
        </div>

        <Tip ref="snTip" :msg="`确认生成SN数据（SN：${sn}）`" title="导出SN数据提示">
            <template v-slot:confirm_btn>
                <div class="button del" @click="confirmExport">
                    <span>确认</span>
                </div>
            </template>
        </Tip>
    </div>
</template>
<script>
export default({
    name: 's1-export-sn',
    data() {
        return {
            snData: {},
            sn: '',
            formRule: {
                manufacturer: [this.requiredRule('请输入生产厂家代码')],
                model_code: [this.requiredRule('请输入机型代码')],
                country: [this.requiredRule('请输入国家代码')],
                year: [this.requiredRule('请输入年份')],
                month: [this.requiredRule('请输入月份')],
                batch_code: [this.requiredRule('请输入批次号')],
                number: [this.requiredRule('请输入数量')]
            }
        }
    },
    watch: {
        snData: {
            handler(nVal) {
                this.sn = (nVal.manufacturer || '') + (nVal.model_code || '') + (nVal.country || '') + (nVal.year || '') + (nVal.month || '') + (nVal.batch_code || '') + '0001';
            },
            deep: true
        }
    },
    created() {
        
    },
    methods: {
        onSubmit() {
            this.$refs.exportSN.validate(v => {
                if(v) {
                    this.$refs.snTip.show = true;
                }
            })
        },
        confirmExport() {
            this.snData.number = parseInt(this.snData.number);
            this.api.ptAddS1Sn(this.snData).then(data => {
                this.exportSn(data.data);
            })
        },
        exportSn(id) {
            this.api.ptExportS1Sn({config_id: id}).then(data => {

            })
        }
    }
})
</script>
<style lang="less" scoped>
    .sn{
        margin-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/view/product-test-tool/s1/export-sn.vue